import { ImageMetaData } from "@/models/image-meta-data";
import { CurriculumType } from "@/util/enum";

export interface ConversationDetailResponseModel {
	name: string;
	description: string;
	conversationId: number;
	appVersion: string;
	appCulture: string;
	metaData: string;
	title?: string;
	imageUrl: string;
	exposureSequence?: number;
	exposureSequenceInMethodology?: number;
	versionGroupId?: string;
	versionGroup?: string;
	curriculumType?: CurriculumType;
	luisAppId: string;
	luisAccountId?: number;
	unitId?: number;
	parentContentId?: string;
	publishStatusId: number;
	cluAccountId?: number;
}

export interface UpsertConversationRequestModel {
	conversationId?: number;
	name: string;
	masterConversationId?: string | number;
	description: string;
	contentId?: string | number;
	exposureId?: string | number;
	unitId?: number;
	metaData: any;
	imageUrl: string;
	pageId: string | null;
	pageMetaData: ImageMetaData | null;
	testConversationId?: number;
	testMetaData?: string;
}

export interface InteractionStyleModel {
	id: number;
	name: string;
}

export interface DeletedNodeRequestModel {
	nodeId: number;
	nodeType: number;
}

export interface UpsertConversationResponseModel {
	conversationId: number;
	masterConversationId?: number;
}

export interface ConversationPublishResponseModel {
	conversationId: number;
	luisAccountId: number;
	luisAppId: string;
	appVersion: string;
	metaData: any;
}



export enum VoiceGenStatus {
	None = -1,
	Queued = 1,
	Running = 2,
	Success = 3,
	Error = 4,
	NoVoiceError = 5,
	waitingForNextStatus = 6
}

export interface SaveExposureConversationDetailModel {
	exposureId: string;
	conversationId?: number | null;
	openDialogId?: number | null;
	closeDialogId?: number | null;
	isComplete: boolean;
}
export interface SaveExposureConversationResponseModel {
	conversationId?: number | null;
	publishDetails?: ConversationPublishResponseModel;
}
export interface ExposureConversationDetailModel {
	exposureId: string;
	conversationId?: number | null;
	openDialogId?: number | null;
	closeDialogId?: number | null;
	isComplete: boolean;
	isCustomConversation: boolean;
	deleteCustomConversation: boolean;
}

export interface RemoveExposureTemplateAssociationModel {
	exposureId: number;
	openDialogId: number;
	closeDialogId: number;
}
export interface MasterConversationDetailResponseModel {
	id: number;
	text: string;
	metaData: string;
	type: string;
	conversationId: number;
	// at the moment, they don't come through service
	intents: number;
	dialogs: number;
}

export interface CopyImageRequestModel {
	identifier: string;
	sourceURL: string;
	targetURL: string;
}

export interface ConversationChatModel {
	id: number;
	name: string;
	description: string;
	luisAppId: string;
	isPublished: boolean;
	imageUrl: string;
	luisAccountId?: number;
	statusId: number;
	isMaster: boolean;
	appCulture: string;
	appVersion: string;
	predictionKey: string;
	predictionEndpoint: string;
	conversationDialog: ConversationDialogChatModel[];
	intentMatchThreshold: number;
	speechConfig: SpeechConfigModel;
}

export interface ConversationChatModelV2 extends ConversationChatModel {
	projectName?: string;
	deploymentName?: string;
	endPoint?: string;
	key?: string;
	publishStatusId?: number;
	cluAccountId?: number;
}

export interface ConversationDialogChatModel {
	id: number;
	imageUrl: string;
	order: number;
	retryCount: number;
	currentRetryCount: number;
	currentSilentRetryCount: number;
	currentAlternateRetryCount: number;
	isHead: boolean;
	isOptional: boolean;
	value: string;
	statusId: number;
	nextDialogId?: number;
	name: string;
	path: ConversationPathChatModel[];
	alternateDialog: ConversationAlternateDialogChatModel[];
	interactionStyleId: number;
	isConclusion: boolean;
}

export interface ConversationPathChatModel {
	id: number;
	nextDialogId?: number;
	pathTypeId: number;
	order: number;
	statusId: number;
	value: string;
	imageUrl: string;
	isFallback: boolean;
	intent: ConversationIntentChatModel[];
	pathEntityValue: ConversationPathEntityValueChatModel[];
	interactionStyleId: number;
}

export interface ConversationPathEntityValueChatModel {
	id: number;
	value: string;
	entityId: number;
	pathId: number;
	entityName: string;
	luisId?: string;
}

export interface ConversationAlternateDialogChatModel {
	id: number;
	value: string;
	statusId: number;
	dialogTypeId: number;
	imageUrl: string;
	voiceUrl: string;
	sequence: number;
}

export interface ConversationIntentChatModel {
	id: number;
	name: string;
	statusId: number;
	luisIntentId: string;
	utterence: ConversationUtterenceChatModel[];
}

export interface ConversationUtterenceChatModel {
	id: number;
	value: string;
	order: number;
	statusId: number;
	luisUtterenceId?: number;
	isPattern: boolean;
	entityId?: number;
}

export interface TestConversationDetailsDto {
	id: number;
	metaData: string;
	appVersion: string;
	appCulture?: string;
	intentMatchThreshold?: number | null;
	luisAppId: string;
	luisAccountId?: number;
}
export interface SpeechConfigModel {
	speechKey: string;
	speechRegion: string;
}

export interface QueryCLURequestModel {
	deploymentName: string;
	projectName?: string;
	endPoint: string;
	key: string;
	queryText: string;
}

export interface AddConversationTemplateModel {
	conversationName: string;
	masterConversationName?: string;
}

export interface QueryCLUResponseModel {
	prediction: QueryPrediction;
}

export interface QueryPrediction {
	topIntent?: string;
	intentts: CLUIntent[];
	entities: CLUEntity[];
}

export interface CLUEntity {
	category: string;
	text: string;
}

export interface CLUIntent {
	category: string;
	confidenceScore: number;
}
